"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_KEY_TYPES = exports.ED25519_KEY_TYPE = exports.ECC_COMPACT_KEY_TYPE = void 0;
exports.ECC_COMPACT_KEY_TYPE = 0;
exports.ED25519_KEY_TYPE = 1;
exports.SUPPORTED_KEY_TYPES = [
    exports.ECC_COMPACT_KEY_TYPE,
    exports.ED25519_KEY_TYPE,
];
//# sourceMappingURL=KeyType.js.map